import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DrugCategoryButton.module.scss";

/**
 * Individual button for each drug category letter (A, B, C, etc.)
 * Note: only available categories are rendered (unavailable ones are filtered out).
 */
const DrugCategoryButton = ({
  letter,
  isActive = false,
  isAvailable,
  onClick = null,
  className = "",
}) => {
  const buttonClasses = classNames(
    styles.categoryButton,
    {
      [styles.active]: isActive,
    },
    className,
  );

  const handleClick = () => {
    if (isAvailable && onClick) {
      onClick();
    }
  };

  const handleKeyDown = (event) => {
    if ((event.key === "Enter" || event.key === " ") && isAvailable) {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={!isAvailable}
      aria-pressed={isActive}
      aria-label={`Jump to drug category ${letter}`}
      title={
        isAvailable
          ? `Jump to drug category ${letter}`
          : `No drugs available for category ${letter}`
      }
    >
      <span className={styles.letter}>{letter}</span>
    </button>
  );
};

DrugCategoryButton.propTypes = {
  letter: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isAvailable: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default DrugCategoryButton;
